import t from "../../Actions/CurrentVisitorPermitActions/types";

const intitialState = {
  currentVisitorPermit: [],
  QuickPermitSetupDetail: {},
  QuickPermitPinDetail: {},
};

const CurrentVisitorPermitReducer = (state = intitialState, action) => {
  switch (action.type) {
    case t.FETCH_CURRENT_VISITOR_PERMIT:
      return {
        ...state,
        currentVisitorPermit: action.payload,
      };
    case t.FETCH_QUICK_PERMIT_SETTING_DETAILS:
      return {
        ...state,
        QuickPermitSetupDetail: action.payload,
      };
    case "FETCH_QUICK_PERMIT_SETTING_DETAILS_BLANK":
      return {
        ...state,
        QuickPermitSetupDetail: {},
      };
    case t.FETCH_QUICK_PERMIT_PIN_DETAILS:
      return {
        ...state,
        QuickPermitPinDetail: action.payload,
      };
    default:
      return state;
  }
};

export default CurrentVisitorPermitReducer;
